import { SELECIONAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM } from '../types'

export default function selecionarReservasExcessoBagagem (reservas) {
  return {
    type: SELECIONAR_RESERVAS_MARCACAO_EXCESSO_BAGAGEM,
    payload: reservas
  }
}